// FaqList.vue, HistoryMsgList.vue, MsgList.vue
export const searchLayoutHelper = {
  data() {
    return {
      scenarioContent: [],
      messageType: 'FAQ',
      searchTextFocus: false,
      searchTextWrtie: false,
      searchText: ''
    };
  },
  methods: {
    isSearchButton(chat) {
      if (chat) {
        const scenarioContent = JSON.parse(chat.content);
        return !scenarioContent.buttons && scenarioContent.parentCode;
      }
    },
    setSearchTextFocus(data) {
      this.searchTextFocus = data;
      this.setSearchTextWrite();
    },
    setSearchTextWrite() {
      if (this.searchText) {
        this.searchTextWrtie = true;
      } else {
        this.searchTextWrtie = false;
      }
    },
    isPreview(chatRoomId) {
      if (chatRoomId) {
        return false;
      } else {
        return true;
      }
    }
  }
};

// FaqList.vue
export const searchActionHelper = {
  methods: {
    searchAction() {
      if (this.searchText) {
        const item = {
          text: this.searchText,
          code: ''
        };
        this.sendSearch(item, 'FAQ', 'SEARCH');
      }
    },

    sendSearch(item, type, contentType) {
      if (!this.chatRoomId) {
        return;
      }

      let content = {
        type: contentType === 'RESULT' ? (item.type === 'FAQ_SEARCH' ? 'TEXT' : 'SEARCH_BUTTON') : 'SEARCH_BUTTON',
        code: item.code,
        text: item.text
      };

      this.loading = true;

      this.$http({
        method: 'POST',
        url: '/api/external/webchat/sendMessage',
        data: {
          senderUid: this.senderUid,
          chatRoomId: this.chatRoomId,
          messageType: type,
          scenarioTemplateCode: item.code,
          content: JSON.stringify(content)
        }
      })
        .then((result) => {
          try {
            if (result) {
              if (result.data.code !== 0) {
                if (this.isNotAvailable(result.data)) return;
                this.$mitt.emit('DialogPopup', {
                  useDialog: true,
                  message: '<dl class="txt"><dd>' + result.data.message + '</dd></dl>'
                });
              }
            }
          } catch (e) {
            this.loading = false;
            this.searchText = '';
            document.activeElement.blur();
          }
        })
        .catch((errorMsg) => {
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>' + errorMsg + '</dd></dl>'
          });
        })
        .finally(() => {
          this.loading = false;
          this.searchText = '';
          document.activeElement.blur();
        });
    }
  }
};

// WebChat.vue
export const webchatLayoutHelper = {
  data() {
    return {
      isFaq: false
    };
  },
  methods: {
    setFaq(boolean) {
      this.isFaq = boolean;
    }
  }
};
